import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from "reactstrap";
import {useHistory} from "react-router-dom";
import Swal from "sweetalert2";

const LoginMethod = (props) => {
    const history = useHistory();
    const [methods, setMethods] = useState(["email"]);
    const [assessmentInfo, setAssesssmentInfo] = useState({assessmentName: "error", assessmentFor: "error"});

    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.userData.eventData?.assessmentName && props.userData.eventData?.assessmentFor) {
            setAssesssmentInfo({
                assessmentName: props.userData.eventData?.assessmentName,
                assessmentFor: props.userData.eventData?.assessmentFor
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Event Lost',
                text: 'Kindly Create Event Again',
                confirmButtonText: 'Proceed',
                allowOutsideClick: false
            }).then(result => {
                if (result.isConfirmed) {

                    history.push("/assessment/info");
                }
            })
        }
    }, [])
    const handleSubmit = () => {

        props.setUserData({
            ...props.userData,
            eventData: {...props.userData.eventData, loginMethod: methods}
        });
        history.push("/assessment/artWork");
    }

    const previous = () => {
        history.goBack();
    }
    return (
        <Container className="ml-0 right-content-container">
            <Row className="">
                <Col>
                    <h1 className="">Your <span
                        className="active-text-color text-capitalize">{assessmentInfo.assessmentName} </span>
                        For <span className="warning-text-color text-capitalize">{assessmentInfo.assessmentFor}</span>
                    </h1>
                    <hr className="mb-0 mt-1 heading-hr mx-2"/>
                </Col>
            </Row>
            <div>
                <h2 className="active-text-color">Login Method</h2>
                <div className="">
                    <div>
                        <span
                            className='fs-14'>Select your preferred Log In method for your {props.signedInUser.projectType !== "progress" && "assessment"} game</span>
                        <div className="inner-assessment-content">
                            <div style={{padding: "20px 0"}}>
                                <Row className='mb-3'>
                                    <Col lg={4} sm={12}>
                                        <div>
                                            <input
                                                className="auth-checkbox mx-2"
                                                type="checkbox"
                                                id="selectAll"
                                                name="selectAll"
                                                checked={methods.includes("email")}
                                                onChange={(e) => {
                                                    let tempArray = [...methods];

                                                    if (e.target.checked) {
                                                        tempArray.push("email");
                                                    } else if (!e.target.checked) {
                                                        let index = tempArray.indexOf("email");
                                                        if (index > -1) {
                                                            tempArray.splice(index, 1);
                                                        }
                                                    }
                                                    setMethods([...tempArray]);
                                                }}
                                            />
                                            <label className='radio-label' htmlFor="selectAll">Personal Email
                                                Address</label>
                                        </div>
                                    </Col>
                                    {/*<Col lg={4} sm={12}>*/}
                                    {/*    <div>*/}
                                    {/*        <input*/}
                                    {/*            className="checkbox-round1 mx-2"*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="field1"*/}
                                    {/*            name="field1"*/}
                                    {/*            disabled={true}*/}
                                    {/*            // checked={methods.includes("linkedIn")}*/}
                                    {/*            // onChange={(e) => {*/}
                                    {/*            //     let tempArray = [...methods];*/}
                                    {/*            //     console.log(e.target.checked);*/}
                                    {/*            //     if (e.target.checked) {*/}
                                    {/*            //         tempArray.push("linkedIn");*/}
                                    {/*            //     } else if (!e.target.checked) {*/}
                                    {/*            //         let index = tempArray.indexOf("linkedIn");*/}
                                    {/*            //         if (index > -1) {*/}
                                    {/*            //             tempArray.splice(index, 1);*/}
                                    {/*            //         }*/}
                                    {/*            //     }*/}
                                    {/*            //     setMethods([...tempArray]);*/}
                                    {/*            // }}*/}
                                    {/*        />*/}
                                    {/*        <label className='radio-label' htmlFor="field1">LinkedIn*/}
                                    {/*            profile</label>*/}
                                    {/*    </div>*/}
                                    {/*</Col>*/}
                                    {/*<Col sm={3}>*/}
                                    {/*    <div>*/}
                                    {/*        <input*/}
                                    {/*            className="checkbox-round1 mx-2"*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="field2"*/}
                                    {/*            name="field2"*/}
                                    {/*            disabled={true}*/}
                                    {/*        />*/}
                                    {/*        <label className='radio-label text-muted' htmlFor="field2">Facebook*/}
                                    {/*            profile</label>*/}
                                    {/*    </div>*/}
                                    {/*</Col>*/}
                                    {/*<Col sm={3}>*/}
                                    {/*    <div>*/}
                                    {/*        <input*/}
                                    {/*            className="checkbox-round1 mx-2"*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="field3"*/}
                                    {/*            name="field3"*/}
                                    {/*            disabled={true}*/}
                                    {/*        />*/}
                                    {/*        <label className='radio-label text-muted' htmlFor="field3">Google </label>*/}
                                    {/*    </div>*/}
                                    {/*</Col>*/}
                                    {/*<Col sm={3}>*/}
                                    {/*    <div>*/}
                                    {/*        <input*/}
                                    {/*            className="checkbox-round1 mx-2"*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="field3"*/}
                                    {/*            name="field3"*/}
                                    {/*            disabled={true}*/}
                                    {/*        />*/}
                                    {/*        <label className='radio-label text-muted' htmlFor="field3">Apple </label>*/}
                                    {/*    </div>*/}
                                    {/*</Col>*/}
                                </Row>
                            </div>
                        </div>
                    </div>
                    <Row className="buttons-div">
                        <Col sm={12} xs={12} md={6} lg={8}></Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="previous-button text-white w-100" onClick={previous}
                                    color="">Previous</Button>
                        </Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                    onClick={handleSubmit}
                                    color="">Next</Button>
                        </Col>
                    </Row>
                    {/*<div className="buttons-div">*/}
                    {/*    <div className="d-flex align-items-center" role="button">*/}
                    {/*        <img src={demoButton} alt="" height={17}/>*/}
                    {/*        <span className="text-dark font-weight-600 mx-2">Previous</span>*/}
                    {/*    </div>*/}
                    {/*    <div className="btn-vr"/>*/}
                    {/*    <div className="d-flex align-items-center" role="button" onClick={submitForm}>*/}
                    {/*        <span className="font-weight-600 mx-2 active-text-color">Next</span>*/}
                    {/*        <img src={nextBUtton} alt="" height={17}/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </Container>
    );
};

export default LoginMethod;